<template>
  <div
    v-if="popupMessageNotEmpty"
    class="modal"
    @click="hidePopUp"
    @blur="hidePopUp"
  >
    <div
      class="popup-window"
      @click.stop
    >
      <em
        :style="getCustomIconStyle(iconPath('x'))"
        class="custom-icons close-popup-button bg-icon-default h-5 w-5 pt"
        @click="hidePopUp"
      />
      <div class="action-font popup-message">
        {{ $store.getters.getPopUpMessage }}
      </div>
      <input
        type="button"
        value="OK"
        class="popup-window-button"
        @click="hidePopUp"
      />
      <div style="clear: both" />
    </div>
  </div>
</template>

<script>
import useCustomIcon from '@/utilities/composables/useCustomIcon';

export default {
  name: 'PopUpMessage',

  setup() {
    const { iconPath, getCustomIconStyle } = useCustomIcon();

    return {
      iconPath,
      getCustomIconStyle,
    };
  },

  computed: {
    popupMessageNotEmpty() {
      return this.$store.getters.getPopUpMessage !== '';
    },
  },

  methods: {
    hidePopUp() {
      this.$store.dispatch('setPopUpMessage', '');
    },
  },
};
</script>

<style lang="scss">
.popup-window {
  width: 40%;
}

.popup-message {
  display: block;
  float: left;
  clear: both;
  margin-top: 30px;
  margin-bottom: 30px;
  font-size: 30px;
  width: 100%;
}
</style>
